var portfolioPositionsList = {
	caption: "Portfolio Positionen",
	name: "Name",
	isin: "ISIN",
	numberOfShares: "Anzahl/Nennwert",
	price: "Preis",
	dateTime: "Zeit/Datum",
	todayChange: "Heutige Änderung ",
	unrealizedPerformance: "Nicht realisierte G u V",
	marketValue: "Marktwert",
	purchaseValue: "Kaufwert",
	weight: "Gewicht %",
	actions: "Aktionen",
	noPositions: "Keine Positionen.",
	averagePurchasePrice: "Durchschn. Kaufpreis"
};
var de = {
	portfolioPositionsList: portfolioPositionsList
};

export { de as default, portfolioPositionsList };
